module.exports = __webpack_public_path__ + "static/integrated_payments_header_image-10af460700155e606b346dfee8ab84f3.png";